import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  imports: [ToastModule, CommonModule],
  providers: [MessageService],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnInit {
  constructor(
    private _messageService: MessageService,
    private _toastService: ToastService,
  ) {}

  message: any;
  messagelife: any = 2000;

  ngOnInit(): void {
    this._toastService.getToast().subscribe((toastMessage) => {
      this.message = toastMessage;
      if (this.message) {
        this.show();
      }
    });
  }

  show() {
    this._messageService.clear();
    this._messageService.add({
      severity: this.message.severity,
      summary: this.message.summary,
      detail: this.message.detail,
      icon: this.message.icon,
      closable: false,
    });
  }

  dismiss() {
    this._messageService.clear();
  }
}
